/* eslint-disable */
import * as React from 'react';
import { useEffect, useState } from 'react';
import activosApi from 'api/activos';
import { useNavigate } from 'react-router-dom';
// Chakra imports
import {
  Badge,
  Button,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Icon,
  Stack,
  Box,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Select,
  useToast,
  AbsoluteCenter,
  border,
  Divider,
  Checkbox,
  HStack,
  SimpleGrid,
  Image,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Skeleton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverCloseButton,
  Portal,
} from '@chakra-ui/react';

import {
  MdMenu, MdFilterList, MdDownload, MdViewColumn,
  MdInfoOutline, MdLocationOn, MdAttachMoney, MdShoppingCart,
} from 'react-icons/md';

// Framer Motion
import { motion, AnimatePresence } from 'framer-motion';

const MotionTr = motion(Tr as any);
// Custom components   
import { MdChevronRight, MdChevronLeft, MdAdd, MdClose, MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import MultiActions from 'components/actions/MultiActions';
import { isSoloLectura } from 'utils/permissions';
// Assets  
import { SearchBar } from "components/navbar/searchBar/SearchBar";

import {
  PaginationState,
  createColumnHelper,
  useReactTable,
  ColumnFiltersState,
  VisibilityState,
  getCoreRowModel,
  getFilteredRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFacetedMinMaxValues,
  getPaginationRowModel,
  getSortedRowModel,
  flexRender,
} from '@tanstack/react-table'

// Columnas configurables, agrupadas por tema para que el selector sea fácil
// de escanear. 'actions' se deja fuera a propósito: es la columna de botones
// de acción, no información del activo, así que siempre se queda visible.
const GRUPOS_COLUMNAS: { titulo: string; icon: any; columnas: { id: string; label: string }[] }[] = [
  {
    titulo: 'General',
    icon: MdInfoOutline,
    columnas: [
      { id: 'name', label: 'Nombre del activo' },
      { id: 'folio', label: 'Folio' },
      { id: 'serialNumber', label: 'Número de serie' },
      { id: 'estado', label: 'Estado' },
    ],
  },
  {
    titulo: 'Ubicación y asignación',
    icon: MdLocationOn,
    columnas: [
      { id: 'departamento', label: 'Ubicación' },
      { id: 'departamentoOrigen', label: 'Depto. origen' },
      { id: 'hotel', label: 'Hotel' },
      { id: 'ubicacionExacta', label: 'Ubicación exacta' },
      { id: 'usuarioDueno', label: 'Usuario asignado' },
    ],
  },
  {
    titulo: 'Financiero',
    icon: MdAttachMoney,
    columnas: [
      { id: 'price', label: 'Precio' },
      { id: 'precioDepreciado', label: 'Precio depreciado' },
      { id: 'rubroDepreciacion', label: 'Rubro de depreciación' },
      { id: 'proveedor', label: 'Proveedor' },
      { id: 'facturaFolio', label: 'Factura' },
      { id: 'garantia', label: 'Garantía' },
    ],
  },
  {
    titulo: 'Adquisición',
    icon: MdShoppingCart,
    columnas: [
      { id: 'tipoAdquisicion', label: 'Tipo adquisición' },
      { id: 'arrendadora', label: 'Arrendadora' },
      { id: 'fechaAdquisicion', label: 'Fecha de adquisición' },
      { id: 'date', label: 'Fecha de registro' },
    ],
  },
];
const COLUMNAS_CONFIGURABLES: { id: string; label: string }[] = GRUPOS_COLUMNAS.flatMap(g => g.columnas);
const COLUMN_VISIBILITY_STORAGE_KEY = 'listaActivos.columnVisibility';

const actionsToolbarVariants = {
  hidden: {
    opacity: 0,
    y: -10, // Inicia ligeramente arriba
    scale: 0.95,
    transition: {
      duration: 0.2,
      ease: "easeInOut"
    }
  },
  visible: {
    opacity: 1,
    y: 0, // Baja a su posición original
    scale: 1,
    transition: {
      duration: 0.3,
      ease: [0.16, 1, 0.3, 1] // Easing suave idéntico al de la tabla
    }
  },
  exit: {
    opacity: 0,
    y: -10, // Se desvanece subiendo un poco
    scale: 0.95,
    transition: {
      duration: 0.2,
      ease: "easeInOut"
    }
  }
};

// Animaciones
const tableVariants = {
  hidden: {
    x: 0,
    transition: {
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1] // Curva de easing personalizada
    }
  },
  visible: {
    x: '-1%',
    transition: {
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1],
      when: "beforeChildren" // Asegura que la animación padre termine primero
    }
  }
};

const formVariants = {
  hidden: {
    opacity: 0,
    x: '100%',
    transition: {
      duration: 0.3
    }
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.3
    }
  },
  exit: {
    opacity: 0,
    x: '100%',
    transition: {
      duration: 0.3
    }
  }
};


type RowObj = {
  name: string;
  URL_Imagen: string; // Añadir esta propiedad
  departamento: string;
  departamentoOrigen: string;
  hotel: string;
  date: string;
  estado: string;
  price: string;
  serialNumber: string;
  actions: string;
  modelo: string;
  usuarioDueno: string;
  folio?: string;
  tipoAdquisicion: string;
  proveedor?: string;
  garantia?: string;
  rubroDepreciacion?: string;
  precioDepreciado?: string;
  ubicacionExacta?: string;
  fechaAdquisicion?: string;
  arrendadora?: string;
  facturaFolio?: string;
};


const BULK_ACTIONS_CONFIG = [
  {
    id: 'baja',
    label: 'Dar de Baja',
    colorScheme: 'red',
    icon: MdClose,
    // Define el comportamiento específico o la redirección
    handler: (ids: number[], navigate: any) => {
      navigate('/admin/main/ver/salidas', { state: { actionType: 'baja', assetIds: ids } });
    }
  },
  {
    id: 'salida_temporal',
    label: 'Salida Temporal',
    colorScheme: 'blue',
    icon: MdChevronRight, // Puedes cambiarlo por tu icono ideal
    handler: (ids: number[], navigate: any) => {
      navigate('/admin/main/ver/salidas', { state: { actionType: 'salida_temporal', assetIds: ids } });
    }
  },
  // 💡 En el futuro, agregar una nueva opción masiva es tan fácil como descomentar esto:
  /*
  {
    id: 'mantenimiento',
    label: 'Mandar a Mantenimiento',
    colorScheme: 'orange',
    icon: MdBuild, 
    handler: (ids: number[], navigate: any) => {
      // Tu lógica de negocio o llamada directa a API externa aquí
    }
  }
  */
];


export default function SearchTableOrders() {
  const textColor = useColorModeValue("navy.700", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const brandColor = useColorModeValue("brand.500", "brand.400");
  const navigate = useNavigate();
  const toast = useToast();
  const [columnFilters, setColumnFilters] = React.useState<ColumnFiltersState>([]);
  const [globalFilter, setGlobalFilter] = React.useState('');
  // Qué columnas quiere ver cada quién: se guarda por navegador (localStorage),
  // no por usuario en el servidor — es una preferencia de vista, no un dato.
  const [columnVisibility, setColumnVisibility] = React.useState<VisibilityState>(() => {
    try {
      const guardado = localStorage.getItem(COLUMN_VISIBILITY_STORAGE_KEY);
      return guardado ? JSON.parse(guardado) : {};
    } catch {
      return {};
    }
  });
  React.useEffect(() => {
    try {
      localStorage.setItem(COLUMN_VISIBILITY_STORAGE_KEY, JSON.stringify(columnVisibility));
    } catch {
      // localStorage no disponible (modo privado, etc.) — no es crítico, se ignora.
    }
  }, [columnVisibility]);
  const [data, setData] = React.useState<RowObj[]>([]);
  const [filteredData, setFilteredData] = useState<RowObj[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedHotel, setSelectedHotel] = useState<string>(() => {
    return sessionStorage.getItem('hotelSeleccionado') || '';
  });

  // Estados para el flujo de baja
  const [showBajaForm, setShowBajaForm] = useState(false);
  const [currentAsset, setCurrentAsset] = useState<RowObj | null>(null);
  const [bajaStep, setBajaStep] = useState(1);
  const [bajaData, setBajaData] = useState({
    motivo: '',
    comentarios: '',
    fechaBaja: new Date().toISOString().split('T')[0],
    responsable: '',
    firmante: '',
    correoFirmante: '',
    jefe: '',
    correoJefe: '',
  });


  // Estados para selección múltiple
  const [multiSelectMode, setMultiSelectMode] = useState(false);
  const [selectedAssets, setSelectedAssets] = useState<Map<string, { motivo: string; file: File | null }>>(new Map());

  const [showBulkBaja, setShowBulkBaja] = useState(false);



  const hotelMap: Record<string, string> = {
    "gvrn": "Grand Velas Riviera Nayarit",
    "vv": "Velas Vallarta",
    "gvrm": "Grand Velas Riviera Maya",
    "gvlc": "Grand Velas Los Cabos",
    "gvblc": "Grand Velas Boutique Los Cabos",
    "mdc": "Mar del Cabo",
    "cv": "Casa Velas",
    "cc": "Contact Center",

  };




  const hotelIdMap: Record<string, number> = {
    GVRN: 1,
    GVRM: 2,
    GVBLC: 3,
    GVLC: 4,
    VV: 5,
    CV: 6,
    MDC: 7,
    CC: 8,
    DEMO: 9
  };

  const fetchActivos = async (hotelCode: string) => {
    setIsLoading(true);
    try {
      // 1. Obtener el ID del hotel según el código seleccionado
      const hotelId = hotelIdMap[hotelCode];
      if (!hotelId) {
        console.error('Hotel no válido:', hotelCode);
        return;
      }

      // 2. Llamar a la API con el ID del hotel
      const activos = await activosApi.listadoPorPropiedad(hotelId); // Asegúrate que tu API acepte un número

      // 3. Mapear los datos igual que antes
      const mappedData = activos.map((activo: any) => ({
        name: activo.ActiveName,
        URL_Imagen: activo.URL_Imagen,
        departamento: activo.Departamento,
        departamentoOrigen: activo.DepartamentoOrigen || '',
        hotel: activo.Hotel,
        date: activo.CreatedDate === null ? 'N/A' : new Intl.DateTimeFormat('es-ES', {
          year: 'numeric', month: '2-digit', day: '2-digit'
        }).format(new Date(activo.CreatedDate)),
        estado: activo.Estado === 'active' ? 'ACTIVO' :
          activo.Estado === 'assigned' ? 'ASIGNADO' :
            activo.Estado === 'pending' ? 'PENDIENTE' :
              activo.Estado === 'pending_baja' ? 'PTE. BAJA' :
                activo.Estado === 'baja' ? 'BAJA' :
                activo.Estado === 'inactive' ? 'INACTIVO' :
                  activo.Estado === 'under_warranty' ? 'EN GARANTÍA' :
                    activo.Estado === 'in_maintenance' ? 'EN MANTENIMIENTO' :
                      activo.Estado === 'in_repair' ? 'EN REPARACIÓN' :
                        activo.Estado === 'bodega' ? 'BODEGA' :
                          activo.Estado === 'pending_salida' ? 'PTE. SALIDA' :
                            activo.Estado === 'fuera_propiedad' ? 'FUERA PROPIEDAD' :
                              activo.Estado === 'rma' ? 'RMA' : 'INACTIVO',
        price: `$${activo.Precio}`,
        serialNumber: activo.SerialNumber,
        actions: `${activo.Id}`,
        modelo: activo.Modelo,
        usuarioDueno: activo.activoDueno,
        folio: activo.Folio || 'N/A',
        tipoAdquisicion: activo.TipoAdquisicion || 'Sin clasificar',
        proveedor: activo.Proveedor || '',
        // Garantia puede venir como fecha (YYYY-MM-DD) o como meses (ej. "36")
        // según cómo se haya capturado el activo — se deja tal cual viene, sin
        // forzar un formato de fecha que rompería el caso de "36 meses".
        garantia: activo.Garantia || '',
        rubroDepreciacion: activo.RubroDepreciacion
          ? `${activo.RubroDepreciacion}${activo.PorcentajeDepreciacion != null ? ` (${activo.PorcentajeDepreciacion}% anual)` : ''}`
          : '',
        precioDepreciado: activo.Precio_depreciado != null ? `$${activo.Precio_depreciado}` : '',
        ubicacionExacta: activo.UbicacionExacta || '',
        fechaAdquisicion: activo.FechaAdquisicion ? new Intl.DateTimeFormat('es-ES', {
          year: 'numeric', month: '2-digit', day: '2-digit'
        }).format(new Date(activo.FechaAdquisicion)) : '',
        arrendadora: activo.Arrendadora || '',
        facturaFolio: activo.FacturaFolio || '',
      }));

      setData(mappedData);

      // 4. Filtrar por nombre de hotel (opcional, si la API ya devuelve solo los del hotel, puedes saltarte esto)
      const hotelNombreCompleto = hotelMap[hotelCode.toLowerCase()] || '';
      if (hotelNombreCompleto) {
        setFilteredData(mappedData.filter((item: { hotel: string; }) => item.hotel === hotelNombreCompleto));
      } else {
        setFilteredData(mappedData);
      }
    } catch (error) {
      console.error('Error fetching activos:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Carga inicial
  useEffect(() => {
    const storedHotel = sessionStorage.getItem('hotelSeleccionado') || '';
    if (storedHotel && hotelIdMap[storedHotel]) {
      fetchActivos(storedHotel);
    } else {
      // Fallback: primer hotel del usuario
      const userData = JSON.parse(sessionStorage.getItem('user') || '{}');
      const firstHotel = userData.Hoteles?.split(',')[0] || 'GVRN';
      fetchActivos(firstHotel);
    }
  }, []);

  // Escuchar cambios de hotel desde el Nav
  useEffect(() => {
    const handleHotelChanged = (event: any) => {
      const hotelCode = event.detail.hotel;
      setSelectedHotel(hotelCode);
      sessionStorage.setItem('hotelSeleccionado', hotelCode);
      fetchActivos(hotelCode); // 👈 Recarga los activos del nuevo hotel
    };

    window.addEventListener('hotelCambiado', handleHotelChanged);
    return () => window.removeEventListener('hotelCambiado', handleHotelChanged);
  }, []); // Dependencia vacía, se registra una sola vez

  useEffect(() => {
    const handleHotelChanged = (event: any) => {
      const hotelCode = event.detail.hotel;
      setSelectedHotel(hotelCode);
      sessionStorage.setItem('hotelSeleccionado', hotelCode);

      const hotelNombreCompleto = hotelMap[hotelCode.toLowerCase()] || '';
      if (hotelNombreCompleto && data.length > 0) {
        setFilteredData(data.filter(item => item.hotel === hotelNombreCompleto));
      } else {
        setFilteredData(data);
      }
    };

    window.addEventListener('hotelCambiado', handleHotelChanged);

    return () => {
      window.removeEventListener('hotelCambiado', handleHotelChanged);
    };
  }, [data]);

  // Toggle para activar/desactivar modo selección múltiple
  const toggleMultiSelect = () => {
    setMultiSelectMode(!multiSelectMode);
    if (!multiSelectMode) {
      setSelectedAssets(new Map()); // Limpiar selección al salir del modo
      setShowBulkBaja(false);
    }
  };

  // Manejar selección/deselección de activos
  const handleSelectAsset = (assetId: string) => {
    const asset = filteredData.find(item => item.actions === assetId);
    if (!asset || asset.estado !== "ACTIVO") return;

    setSelectedAssets(prev => {
      const newSelected = new Map(prev);
      if (newSelected.has(assetId)) {
        newSelected.delete(assetId);
      } else {
        newSelected.set(assetId, { motivo: '', file: null });
      }
      setShowBulkBaja(newSelected.size > 0);
      return newSelected;
    });
  };

  const allAssetsHaveMotivo = () => {
    if (selectedAssets.size === 0) return false;
    for (const [, { motivo }] of selectedAssets) {
      if (!motivo) return false;
    }
    return true;
  };

  // Manejar selección/deselección de todos los activos visibles
  const handleSelectAllVisible = () => {
    const activosDisponibles = filteredData.filter(item => item.estado === "ACTIVO");

    if (selectedAssets.size === activosDisponibles.length) {
      setSelectedAssets(new Map());
      setShowBulkBaja(false);
    } else {
      const allIds = new Map<string, { motivo: string; file: File | null }>();
      activosDisponibles.forEach(item => {
        allIds.set(item.actions, { motivo: "", file: null });
      });
      setSelectedAssets(allIds);
      setShowBulkBaja(true);
    }
  };

  const handleOpenBajaFlow = (asset: RowObj) => {
    setCurrentAsset(asset);
    setBajaData({
      motivo: '',
      comentarios: '',
      fechaBaja: new Date().toISOString().split('T')[0],
      responsable: '',
      firmante: '',
      correoFirmante: '',
      jefe: '',
      correoJefe: '',
    });
    setBajaStep(1);
    setShowBajaForm(true);
  };

  // En tu componente de la Tabla de Activos Principal
  const handleOpenBulkBajaFlow = () => {
    // Extraemos los IDs de las claves del Map creadas en la selección masiva
    const idsSeleccionados = Array.from(selectedAssets.keys()).map(id => Number(id));

    if (idsSeleccionados.length === 0) return;

    // Redirigimos a la ruta de Salidas/Bajas inyectando el estado
    navigate('/admin/main/ver/salidas', {
      state: {
        actionType: 'baja',
        assetIds: idsSeleccionados
      }
    });
  };
  const handleCloseBajaFlow = () => {
    setShowBajaForm(false);
    setCurrentAsset(null);
  };

  const handleBajaInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setBajaData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCompleteBaja = async () => {
    try {
      const url = "https://inventariosbackend.velasresorts.com/inventarios/sendDocusign";

      if (currentAsset) {
        // Baja individual
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            tipo: "individual",
            id: currentAsset.actions,
            ...bajaData
          })
        });

        toast({
          title: 'Baja completada',
          description: 'El activo ha sido dado de baja correctamente',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });

        setData(prevData =>
          prevData.map(item =>
            item.actions === currentAsset.actions
              ? { ...item, estado: 'INACTIVO' }
              : item
          )
        );

        setFilteredData(prevData =>
          prevData.map(item =>
            item.actions === currentAsset.actions
              ? { ...item, estado: 'INACTIVO' }
              : item
          )
        );
      } else {
        // Baja múltiple
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            tipo: "multiple",
            ids: Array.from(selectedAssets),
            ...bajaData
          })
        });

        toast({
          title: 'Bajas completadas',
          description: `${selectedAssets.size} activos han sido dados de baja correctamente`,
          status: 'success',
          duration: 5000,
          isClosable: true,
        });

        setData(prevData =>
          prevData.map(item =>
            selectedAssets.has(item.actions)
              ? { ...item, estado: 'INACTIVO' }
              : item
          )
        );

        setFilteredData(prevData =>
          prevData.map(item =>
            selectedAssets.has(item.actions)
              ? { ...item, estado: 'INACTIVO' }
              : item
          )
        );

        setSelectedAssets(new Map());
        setShowBulkBaja(false);
      }

      handleCloseBajaFlow();
    } catch (error) {
      console.error("Error al dar de baja:", error);
      toast({
        title: 'Error',
        description: 'Ocurrió un error al dar de baja el/los activo(s)',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };


  const columnHelper = createColumnHelper<RowObj>();
  // Movemos la definición base dentro del componente o la calculamos dinámicamente
  const baseColumns = [
    columnHelper.accessor('name', {
      id: 'name',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>
          NOMBRE DEL ACTIVO
        </Text>
      ),
      cell: (info: any) => (
        <Flex align="center">
          {info.row.original.URL_Imagen && (
            <Image
              src={`https://images.weserv.nl/?url=${encodeURIComponent(info.row.original.URL_Imagen)}&w=60&h=60&fit=cover`}
              alt="Imagen activo"
              boxSize="30px"
              objectFit="cover"
              mr="10px"
              borderRadius="md"
              fallbackSrc="https://via.placeholder.com/30"
            />
          )}
          <Flex direction="column">
            <Text color={textColor} fontSize="md" fontWeight="500">
              {info.getValue()}
            </Text>
            <Text fontSize="sm" fontWeight="bold" color="teal.500">
              {info.row.original.modelo}
            </Text>
          </Flex>
        </Flex>
      )
    }),
    columnHelper.accessor('folio', {
      id: 'folio',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>FOLIO</Text>,
      cell: (info) => <Badge colorScheme='cyan' fontSize='md' fontWeight='500'>{info.getValue()}</Badge>
    }),
    columnHelper.accessor('departamento', {
      id: 'departamento',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>UBICACIÓN</Text>,
      cell: (info) => <Text color={textColor} fontSize='md' fontWeight='500'>{info.getValue()}</Text>
    }),
    columnHelper.accessor('departamentoOrigen', {
      id: 'departamentoOrigen',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>DEPTO. ORIGEN</Text>,
      cell: (info) => <Text color={textColor} fontSize='md' fontWeight='500'>{info.getValue()}</Text>
    }),
    columnHelper.accessor('hotel', {
      id: 'hotel',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>HOTEL</Text>,
      cell: (info) => <Text color={textColor} fontSize='md' fontWeight='500'>{info.getValue()}</Text>
    }),
    columnHelper.accessor('date', {
      id: 'date',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>FECHA DE REGISTRO</Text>,
      cell: (info) => <Text color={textColor} fontSize='md' fontWeight='500'>{info.getValue()}</Text>
    }),
    columnHelper.accessor('estado', {
      id: 'estado',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>ESTADO</Text>,
      cell: (info) => (
<Badge
  colorScheme={
    info.getValue() === "ACTIVO" ? "green" :
    info.getValue() === "ASIGNADO" ? "blue" :
    info.getValue() === "PTE. BAJA" ? "yellow" :
    info.getValue() === "BAJA" ? "red" :
    info.getValue() === "BODEGA" ? "teal" :
    info.getValue() === "INACTIVO" ? "orange" :
    info.getValue() === "PTE. SALIDA" ? "purple" :
    info.getValue() === "FUERA PROPIEDAD" ? "red" :
    info.getValue() === "RMA" ? "cyan" : "gray"
  }
  fontSize='md'
  fontWeight='500'
>
  {info.getValue()}
</Badge>
      )
    }),
    columnHelper.accessor('tipoAdquisicion', {
      id: 'tipoAdquisicion',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>TIPO ADQUISICIÓN</Text>,
      cell: (info) => (
        <Badge
          colorScheme={
            info.getValue() === 'Capex' ? 'blue' :
            info.getValue() === 'OPEX' ? 'orange' :
            info.getValue() === 'Arrendamiento' ? 'purple' : 'gray'
          }
          fontSize='md'
          fontWeight='500'
        >
          {info.getValue()}
        </Badge>
      )
    }),
    columnHelper.accessor('arrendadora', {
      id: 'arrendadora',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>ARRENDADORA</Text>,
      cell: (info) => <Text color={textColor} fontSize='md' fontWeight='500'>{info.getValue() || '—'}</Text>
    }),
    columnHelper.accessor('rubroDepreciacion', {
      id: 'rubroDepreciacion',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>RUBRO DEPRECIACIÓN</Text>,
      cell: (info) => <Text color={textColor} fontSize='md' fontWeight='500'>{info.getValue() || '—'}</Text>
    }),
    columnHelper.accessor('precioDepreciado', {
      id: 'precioDepreciado',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>PRECIO DEPRECIADO</Text>,
      cell: (info) => <Text color={textColor} fontSize='md' fontWeight='500'>{info.getValue() || '—'}</Text>
    }),
    columnHelper.accessor('proveedor', {
      id: 'proveedor',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>PROVEEDOR</Text>,
      cell: (info) => <Text color={textColor} fontSize='md' fontWeight='500'>{info.getValue() || '—'}</Text>
    }),
    columnHelper.accessor('facturaFolio', {
      id: 'facturaFolio',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>FACTURA</Text>,
      cell: (info) => <Text color={textColor} fontSize='md' fontWeight='500'>{info.getValue() || '—'}</Text>
    }),
    columnHelper.accessor('garantia', {
      id: 'garantia',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>GARANTÍA</Text>,
      cell: (info) => <Text color={textColor} fontSize='md' fontWeight='500'>{info.getValue() || '—'}</Text>
    }),
    columnHelper.accessor('fechaAdquisicion', {
      id: 'fechaAdquisicion',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>FECHA DE ADQUISICIÓN</Text>,
      cell: (info) => <Text color={textColor} fontSize='md' fontWeight='500'>{info.getValue() || '—'}</Text>
    }),
    columnHelper.accessor('ubicacionExacta', {
      id: 'ubicacionExacta',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>UBICACIÓN EXACTA</Text>,
      cell: (info) => <Text color={textColor} fontSize='md' fontWeight='500'>{info.getValue() || '—'}</Text>
    }),
    columnHelper.accessor('usuarioDueno', {
      id: 'usuarioDueno',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>Usuario asignado</Text>,
      cell: (info) => <Text color={textColor} fontSize='md' fontWeight='500'>{info.getValue()}</Text>
    }),
    columnHelper.accessor('serialNumber', {
      id: 'serialNumber',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>Num. Serie</Text>,
      cell: (info) => <Text color={textColor} fontSize='md' fontWeight='500'>{info.getValue()}</Text>
    }),
    columnHelper.accessor('price', {
      id: 'price',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>PRECIO</Text>,
      cell: (info) => <Text color={textColor} fontSize='md' fontWeight='500'>{info.getValue()}</Text>
    }),
    columnHelper.accessor('actions', {
      id: 'actions',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>ACCIONES</Text>,
      cell: (info) => (
        <MultiActions
          id={info.getValue()}
          editPath="/admin/main/ecommerce/page-example"
          viewPath="/admin/main/ecommerce/page-example"
          onDelete={(id) => {
            setData(prev => prev.filter(item => item.actions !== id));
          }}
          onDeactivate={(id) => {
            // Redirección directa para baja individual
            navigate('/admin/main/ver/salidas', {
              state: {
                actionType: 'baja',
                assetIds: [Number(id)]
              }
            });
          }}
          showDeactivate={!multiSelectMode}
        />
      )
    })
  ];

  // Generamos las columnas finales dependiendo de si está activo el modo selección múltiple
  // Define esto dentro de tu componente SearchTableOrders
  const columns = React.useMemo(() => {
    const selectionColumn = columnHelper.display({
      id: 'select',
      header: () => (
        <Box
          transition="all 0.4s cubic-bezier(0.16, 1, 0.3, 1)"
          w={multiSelectMode ? "40px" : "0px"}
          opacity={multiSelectMode ? 1 : 0}
          overflow="hidden"
          whiteSpace="nowrap"
        >
          <Checkbox
            isChecked={filteredData.length > 0 && selectedAssets.size === filteredData.filter(item => item.estado === "ACTIVO").length}
            isIndeterminate={selectedAssets.size > 0 && selectedAssets.size < filteredData.filter(item => item.estado === "ACTIVO").length}
            onChange={handleSelectAllVisible}
          />
        </Box>
      ),
      cell: ({ row }) => {
        const assetId = row.original.actions;
        const isActivo = row.original.estado === "ACTIVO";
        return (
          <Box
            transition="all 0.4s cubic-bezier(0.16, 1, 0.3, 1)"
            w={multiSelectMode ? "40px" : "0px"}
            opacity={multiSelectMode ? 1 : 0}
            overflow="hidden"
            whiteSpace="nowrap"
          >
            <Checkbox
              isDisabled={!isActivo}
              isChecked={selectedAssets.has(assetId)}
              onChange={() => handleSelectAsset(assetId)}
            />
          </Box>
        );
      }
    });

    // Retornamos SIEMPRE la columna de selección al principio
    return [selectionColumn, ...baseColumns];
  }, [multiSelectMode, selectedAssets, filteredData]);

  const [{ pageIndex, pageSize }, setPagination] =
    React.useState<PaginationState>({
      pageIndex: 0,
      pageSize: 20,
    });

  const pagination = React.useMemo(() => ({
    pageIndex,
    pageSize,
  }), [pageIndex, pageSize]);

  const [filterEstados, setFilterEstados] = useState<string[]>([]);
  const [filterDepartamentos, setFilterDepartamentos] = useState<string[]>([]);
  const [filterDepartamentosOrigen, setFilterDepartamentosOrigen] = useState<string[]>([]);
  const [filterTiposAdquisicion, setFilterTiposAdquisicion] = useState<string[]>([]);
  const [filterFechaDesde, setFilterFechaDesde] = useState('');
  const [filterFechaHasta, setFilterFechaHasta] = useState('');
  const [filterPrecioMin, setFilterPrecioMin] = useState('');
  const [filterPrecioMax, setFilterPrecioMax] = useState('');

  const toggleFilterEstado = (estado: string) => {
    setFilterEstados(prev =>
      prev.includes(estado) ? prev.filter(e => e !== estado) : [...prev, estado]
    );
  };

  const toggleFilterDepartamento = (dep: string) => {
    setFilterDepartamentos(prev =>
      prev.includes(dep) ? prev.filter(d => d !== dep) : [...prev, dep]
    );
  };

  const toggleFilterDepartamentoOrigen = (dep: string) => {
    setFilterDepartamentosOrigen(prev =>
      prev.includes(dep) ? prev.filter(d => d !== dep) : [...prev, dep]
    );
  };

  const toggleFilterTipoAdquisicion = (tipo: string) => {
    setFilterTiposAdquisicion(prev =>
      prev.includes(tipo) ? prev.filter(t => t !== tipo) : [...prev, tipo]
    );
  };

  const clearFilters = () => {
    setFilterEstados([]);
    setFilterDepartamentos([]);
    setFilterDepartamentosOrigen([]);
    setFilterTiposAdquisicion([]);
    setFilterFechaDesde('');
    setFilterFechaHasta('');
    setFilterPrecioMin('');
    setFilterPrecioMax('');
  };

  const uniqueEstados = React.useMemo(() =>
    [...new Set(filteredData.map(item => item.estado).filter(Boolean))].sort(),
    [filteredData]
  );

  const uniqueTiposAdquisicion = React.useMemo(() =>
    [...new Set(filteredData.map(item => item.tipoAdquisicion).filter(Boolean))].sort(),
    [filteredData]
  );

  const uniqueDepartamentos = React.useMemo(() =>
    [...new Set(filteredData.map(item => item.departamento).filter(Boolean))].sort(),
    [filteredData]
  );

  const uniqueDepartamentosOrigen = React.useMemo(() =>
    [...new Set(filteredData.map(item => item.departamentoOrigen).filter(Boolean))].sort(),
    [filteredData]
  );

  const activeFiltersCount = [
    filterEstados.length > 0,
    filterDepartamentos.length > 0,
    filterDepartamentosOrigen.length > 0,
    filterTiposAdquisicion.length > 0,
    !!filterFechaDesde,
    !!filterFechaHasta,
    !!filterPrecioMin,
    !!filterPrecioMax,
  ].filter(Boolean).length;

  const displayData = React.useMemo(() => {
    let result = filteredData;
    if (filterEstados.length > 0) result = result.filter(item => filterEstados.includes(item.estado));
    if (filterDepartamentos.length > 0) result = result.filter(item => filterDepartamentos.includes(item.departamento));
    if (filterDepartamentosOrigen.length > 0) result = result.filter(item => filterDepartamentosOrigen.includes(item.departamentoOrigen));
    if (filterTiposAdquisicion.length > 0) result = result.filter(item => filterTiposAdquisicion.includes(item.tipoAdquisicion));
    if (filterFechaDesde || filterFechaHasta) {
      result = result.filter(item => {
        if (item.date === 'N/A') return false;
        const [day, month, year] = item.date.split('/');
        const itemDate = new Date(Number(year), Number(month) - 1, Number(day));
        if (filterFechaDesde && itemDate < new Date(filterFechaDesde + 'T00:00:00')) return false;
        if (filterFechaHasta && itemDate > new Date(filterFechaHasta + 'T23:59:59')) return false;
        return true;
      });
    }
    if (filterPrecioMin || filterPrecioMax) {
      result = result.filter(item => {
        const price = parseFloat(item.price.replace('$', '').replace(/,/g, ''));
        if (filterPrecioMin && price < parseFloat(filterPrecioMin)) return false;
        if (filterPrecioMax && price > parseFloat(filterPrecioMax)) return false;
        return true;
      });
    }
    return result;
  }, [filteredData, filterEstados, filterDepartamentos, filterDepartamentosOrigen, filterTiposAdquisicion, filterFechaDesde, filterFechaHasta, filterPrecioMin, filterPrecioMax]);

  useEffect(() => {
    setPagination(prev => ({ ...prev, pageIndex: 0 }));
  }, [filterEstados, filterDepartamentos, filterDepartamentosOrigen, filterTiposAdquisicion, filterFechaDesde, filterFechaHasta, filterPrecioMin, filterPrecioMax]);

  const handleDownloadExcel = () => {
    const headers = [
      'Nombre', 'Modelo', 'Folio', 'Departamento', 'Departamento Origen', 'Hotel',
      'Fecha de Registro', 'Estado', 'Tipo Adquisición', 'Rubro Depreciación',
      'Usuario Asignado', 'Num. Serie', 'Precio', 'Precio Depreciado', 'Proveedor',
      'Garantía', 'Fecha de Adquisición', 'Ubicación Exacta',
    ];
    const rows = displayData.map(item => [
      item.name,
      item.modelo,
      item.folio || 'N/A',
      item.departamento,
      item.departamentoOrigen || 'N/A',
      item.hotel,
      item.date,
      item.estado,
      item.tipoAdquisicion,
      item.rubroDepreciacion || 'N/A',
      item.usuarioDueno,
      item.serialNumber,
      item.price,
      item.precioDepreciado || 'N/A',
      item.proveedor || 'N/A',
      item.garantia || 'N/A',
      item.fechaAdquisicion || 'N/A',
      item.ubicacionExacta || 'N/A',
    ]);
    const csvContent = [headers, ...rows]
      .map(row => row.map(cell => `"${String(cell ?? '').replace(/"/g, '""')}"`).join(','))
      .join('\n');
    const BOM = '﻿';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const today = new Date().toISOString().split('T')[0];
    link.download = `activos_${today}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  const table = useReactTable({
    data: displayData,
    columns,
    state: {
      columnFilters,
      globalFilter,
      pagination,
      columnVisibility,
    },
    onPaginationChange: setPagination,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onColumnVisibilityChange: setColumnVisibility,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
    debugTable: true,
    debugHeaders: true,
    debugColumns: false,
  });

  return (
    <Box position="relative" overflow="hidden" width="100%">
      <AnimatePresence mode="wait">
        <motion.div
          key="table"
          initial="hidden"
          animate={showBajaForm ? "visible" : "hidden"}
          variants={tableVariants}
          style={{
            width: '100%',
            position: 'relative',
            transition: 'transform 0.5s cubic-bezier(0.22, 1, 0.36, 1)' // Easing consistente
          }}
        >
          <Flex
            direction='column'
            w='100%'
            overflowX={{ sm: "scroll", lg: "hidden" }}>
            <Flex
              align={{ sm: "flex-start", lg: "flex-start" }}
              justify={{ sm: "space-between", lg: "space-between" }}
              direction='row'
              w='100%'
              px='22px'
            >
              <SearchBar
                className="p-2 font-lg shadow border border-block"
                placeholder="Buscar..."
                value={globalFilter}
                onChange={(e: { target: { value: React.SetStateAction<string>; }; }) => setGlobalFilter(e.target.value)}
              />

              <HStack spacing={4}>
                <Popover placement="bottom-end" isLazy>
                  <PopoverTrigger>
                    <Button
                      variant={activeFiltersCount > 0 ? "solid" : "outline"}
                      colorScheme={activeFiltersCount > 0 ? "brand" : "gray"}
                      leftIcon={<Icon as={MdFilterList} />}
                    >
                      Filtros {activeFiltersCount > 0 && `(${activeFiltersCount})`}
                    </Button>
                  </PopoverTrigger>
                  <Portal>
                  <PopoverContent w="500px" maxW="95vw" boxShadow="lg" borderRadius="lg">
                    <PopoverCloseButton size="sm" top={3} right={3} />
                    <PopoverBody p={5} pt={6}>
                      <Stack spacing={4}>
                        {/* Estado multi-select */}
                        <FormControl>
                          <FormLabel fontSize="xs" color="gray.400" mb={1}>
                            Estado {filterEstados.length > 0 && <Badge ml={1} colorScheme="brand">{filterEstados.length}</Badge>}
                          </FormLabel>
                          <Box
                            maxH="130px"
                            overflowY="auto"
                            border="1px solid"
                            borderColor="gray.200"
                            borderRadius="md"
                            p={2}
                          >
                            <SimpleGrid columns={2} spacing={1}>
                              {uniqueEstados.map(estado => (
                                <Checkbox
                                  key={estado}
                                  size="sm"
                                  isChecked={filterEstados.includes(estado)}
                                  onChange={() => toggleFilterEstado(estado)}
                                  colorScheme="brand"
                                >
                                  <Text fontSize="xs">{estado}</Text>
                                </Checkbox>
                              ))}
                            </SimpleGrid>
                          </Box>
                        </FormControl>

                        {/* Departamento multi-select */}
                        <FormControl>
                          <FormLabel fontSize="xs" color="gray.400" mb={1}>
                            Departamento {filterDepartamentos.length > 0 && <Badge ml={1} colorScheme="brand">{filterDepartamentos.length}</Badge>}
                          </FormLabel>
                          <Box
                            maxH="120px"
                            overflowY="auto"
                            border="1px solid"
                            borderColor="gray.200"
                            borderRadius="md"
                            p={2}
                          >
                            <SimpleGrid columns={2} spacing={1}>
                              {uniqueDepartamentos.map(dep => (
                                <Checkbox
                                  key={dep}
                                  size="sm"
                                  isChecked={filterDepartamentos.includes(dep)}
                                  onChange={() => toggleFilterDepartamento(dep)}
                                  colorScheme="brand"
                                >
                                  <Text fontSize="xs" noOfLines={1}>{dep}</Text>
                                </Checkbox>
                              ))}
                            </SimpleGrid>
                          </Box>
                        </FormControl>

                        {/* Departamento de Origen multi-select */}
                        <FormControl>
                          <FormLabel fontSize="xs" color="gray.400" mb={1}>
                            Departamento de Origen {filterDepartamentosOrigen.length > 0 && <Badge ml={1} colorScheme="brand">{filterDepartamentosOrigen.length}</Badge>}
                          </FormLabel>
                          <Box
                            maxH="120px"
                            overflowY="auto"
                            border="1px solid"
                            borderColor="gray.200"
                            borderRadius="md"
                            p={2}
                          >
                            <SimpleGrid columns={2} spacing={1}>
                              {uniqueDepartamentosOrigen.map(dep => (
                                <Checkbox
                                  key={dep}
                                  size="sm"
                                  isChecked={filterDepartamentosOrigen.includes(dep)}
                                  onChange={() => toggleFilterDepartamentoOrigen(dep)}
                                  colorScheme="brand"
                                >
                                  <Text fontSize="xs" noOfLines={1}>{dep}</Text>
                                </Checkbox>
                              ))}
                            </SimpleGrid>
                          </Box>
                        </FormControl>

                        {/* Tipo de adquisición multi-select */}
                        <FormControl>
                          <FormLabel fontSize="xs" color="gray.400" mb={1}>
                            Tipo de adquisición {filterTiposAdquisicion.length > 0 && <Badge ml={1} colorScheme="brand">{filterTiposAdquisicion.length}</Badge>}
                          </FormLabel>
                          <Box
                            maxH="100px"
                            overflowY="auto"
                            border="1px solid"
                            borderColor="gray.200"
                            borderRadius="md"
                            p={2}
                          >
                            <SimpleGrid columns={2} spacing={1}>
                              {uniqueTiposAdquisicion.map(tipo => (
                                <Checkbox
                                  key={tipo}
                                  size="sm"
                                  isChecked={filterTiposAdquisicion.includes(tipo)}
                                  onChange={() => toggleFilterTipoAdquisicion(tipo)}
                                  colorScheme="brand"
                                >
                                  <Text fontSize="xs" noOfLines={1}>{tipo}</Text>
                                </Checkbox>
                              ))}
                            </SimpleGrid>
                          </Box>
                        </FormControl>

                        {/* Fecha y precio en grid */}
                        <SimpleGrid columns={2} spacing={3}>
                          <FormControl>
                            <FormLabel fontSize="xs" color="gray.400" mb={1}>Fecha desde</FormLabel>
                            <Input size="sm" type="date" value={filterFechaDesde} onChange={e => setFilterFechaDesde(e.target.value)} borderRadius="md" />
                          </FormControl>
                          <FormControl>
                            <FormLabel fontSize="xs" color="gray.400" mb={1}>Fecha hasta</FormLabel>
                            <Input size="sm" type="date" value={filterFechaHasta} onChange={e => setFilterFechaHasta(e.target.value)} borderRadius="md" />
                          </FormControl>
                          <FormControl>
                            <FormLabel fontSize="xs" color="gray.400" mb={1}>Precio mínimo</FormLabel>
                            <Input size="sm" type="number" placeholder="0" value={filterPrecioMin} onChange={e => setFilterPrecioMin(e.target.value)} borderRadius="md" />
                          </FormControl>
                          <FormControl>
                            <FormLabel fontSize="xs" color="gray.400" mb={1}>Precio máximo</FormLabel>
                            <Input size="sm" type="number" placeholder="Sin límite" value={filterPrecioMax} onChange={e => setFilterPrecioMax(e.target.value)} borderRadius="md" />
                          </FormControl>
                        </SimpleGrid>
                      </Stack>

                      {activeFiltersCount > 0 && (
                        <Flex justify="flex-end" mt={3}>
                          <Button size="xs" variant="ghost" colorScheme="red" onClick={clearFilters}>
                            Limpiar todo ({activeFiltersCount})
                          </Button>
                        </Flex>
                      )}
                    </PopoverBody>
                  </PopoverContent>
                  </Portal>
                </Popover>
                {/* Botón Maestro para habilitar/deshabilitar Checkboxes */}
                {!isSoloLectura() && (
                  <Button
                    onClick={toggleMultiSelect}
                    variant={multiSelectMode ? "solid" : "outline"}
                    colorScheme={multiSelectMode ? "blue" : "gray"}
                    leftIcon={multiSelectMode ? <Icon as={MdCheckBox} /> : <Icon as={MdCheckBoxOutlineBlank} />}
                  >
                    {multiSelectMode ? "Cancelar selección" : "Seleccionar múltiples"}
                  </Button>
                )}

                {/* ========================================================= */}
                {/* 🔥 ENVOLTORIO ANIMADO PARA LAS ACCIONES MASIVAS           */}
                {/* ========================================================= */}
                {!isSoloLectura() && (
                  <AnimatePresence mode="wait">
                    {multiSelectMode && selectedAssets.size > 0 && (
                      <motion.div
                        key="bulk-actions-menu"
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        variants={actionsToolbarVariants}
                      >
                        <Menu colorScheme="brand">
                          <MenuButton
                            as={Button}
                            colorScheme="brand"
                            rightIcon={<Icon as={MdChevronRight} transform="rotate(90deg)" />}
                            leftIcon={<Icon as={MdMenu} />}
                          >
                            Acciones Masivas ({selectedAssets.size})
                          </MenuButton>
                          <MenuList minW="200px" p={2} borderRadius="xl" boxShadow="xl">
                            {BULK_ACTIONS_CONFIG.map((action) => (
                              <MenuItem
                                key={action.id}
                                onClick={() => {
                                  const idsSeleccionados = Array.from(selectedAssets.keys()).map(id => Number(id));
                                  action.handler(idsSeleccionados, navigate);
                                }}
                                borderRadius="lg"
                                py={2}
                                _hover={{
                                  bg: useColorModeValue(`${action.colorScheme}.50`, `${action.colorScheme}.900`),
                                  color: useColorModeValue(`${action.colorScheme}.600`, `${action.colorScheme}.200`),
                                }}
                              >
                                <HStack spacing={3}>
                                  <Icon as={action.icon} color={`${action.colorScheme}.500`} />
                                  <Text fontWeight="medium" fontSize="sm">{action.label}</Text>
                                </HStack>
                              </MenuItem>
                            ))}
                          </MenuList>
                        </Menu>
                      </motion.div>
                    )}
                  </AnimatePresence>
                )}

                {/* Columnas visibles */}
                <Popover placement="bottom-end" closeOnBlur={true}>
                  <PopoverTrigger>
                    <Button variant="outline" leftIcon={<Icon as={MdViewColumn} />}>
                      Columnas
                      <Badge ml={2} borderRadius="full" colorScheme="blue" fontSize="0.65em">
                        {COLUMNAS_CONFIGURABLES.filter(({ id }) => table.getColumn(id)?.getIsVisible()).length}
                        /{COLUMNAS_CONFIGURABLES.length}
                      </Badge>
                    </Button>
                  </PopoverTrigger>
                  <Portal>
                    <PopoverContent w="420px" maxH="70vh" overflowY="auto">
                      <PopoverCloseButton />
                      <PopoverHeader>
                        <Flex align="center" justify="space-between" pr={6}>
                          <Text fontWeight="700" fontSize="sm">Columnas visibles</Text>
                          <HStack spacing={3}>
                            <Button
                              size="xs" variant="link" colorScheme="blue"
                              onClick={() => COLUMNAS_CONFIGURABLES.forEach(({ id }) => table.getColumn(id)?.toggleVisibility(true))}
                            >
                              Mostrar todas
                            </Button>
                            <Button
                              size="xs" variant="link" colorScheme="gray"
                              onClick={() => COLUMNAS_CONFIGURABLES.forEach(({ id }) => table.getColumn(id)?.toggleVisibility(false))}
                            >
                              Ocultar todas
                            </Button>
                          </HStack>
                        </Flex>
                      </PopoverHeader>
                      <PopoverBody>
                        <Stack spacing={4}>
                          {GRUPOS_COLUMNAS.map((grupo) => (
                            <Box key={grupo.titulo}>
                              <HStack spacing={2} mb={2}>
                                <Icon as={grupo.icon} color="blue.400" w="16px" h="16px" />
                                <Text fontSize="xs" fontWeight="700" color="gray.500" textTransform="uppercase" letterSpacing="0.04em">
                                  {grupo.titulo}
                                </Text>
                              </HStack>
                              <SimpleGrid columns={2} spacingX={3} spacingY={2}>
                                {grupo.columnas.map(({ id, label }) => {
                                  const column = table.getColumn(id);
                                  if (!column) return null;
                                  return (
                                    <Checkbox
                                      key={id}
                                      size="sm"
                                      isChecked={column.getIsVisible()}
                                      onChange={(e) => column.toggleVisibility(e.target.checked)}
                                    >
                                      {label}
                                    </Checkbox>
                                  );
                                })}
                              </SimpleGrid>
                            </Box>
                          ))}
                        </Stack>
                      </PopoverBody>
                      <PopoverFooter>
                        <Button
                          size="xs" variant="ghost" w="100%"
                          onClick={() => setColumnVisibility({})}
                        >
                          Restablecer a lo predeterminado
                        </Button>
                      </PopoverFooter>
                    </PopoverContent>
                  </Portal>
                </Popover>

                {/* Botón Descargar Excel */}
                <Button
                  variant="outline"
                  colorScheme="green"
                  leftIcon={<Icon as={MdDownload} />}
                  onClick={handleDownloadExcel}
                  isDisabled={displayData.length === 0}
                  title={`Descargar ${displayData.length} registros`}
                >
                  Descargar ({displayData.length})
                </Button>

                {/* Botón Crear Activo */}
                {!isSoloLectura() && (
                  <Button onClick={() => navigate('/admin/main/ecommerce/new-product')}>
                    <Icon as={MdAdd} w='16px' h='16px' mr='5px' color={textColor} />
                    Crear Activo
                  </Button>
                )}
              </HStack>
            </Flex>
            <Box w="100%" overflowX="auto">
              <Table variant='simple' color='gray.500' mb='24px'>
                <Thead>
                  {table.getHeaderGroups().map(headerGroup => (
                    <Tr key={headerGroup.id}>
                      {headerGroup.headers.map(header => {
                        return (
                          <Th
                            pe='10px'
                            borderColor={borderColor}
                            key={header.id}
                            colSpan={header.colSpan}
                            // Evita parpadeos de espacio aplicando la misma transición de ancho al TH de selección
                            transition="all 0.4s cubic-bezier(0.16, 1, 0.3, 1)"
                            w={header.id === 'select' ? (multiSelectMode ? "40px" : "0px") : "auto"}
                            p={header.id === 'select' && !multiSelectMode ? "0px" : "12px"}
                          >
                            {/* ... Tu flexRender existente se queda exactamente igual ... */}
                            {header.isPlaceholder ? null : (
                              <Flex
                                {...{
                                  className: header.column.getCanSort() ? 'cursor-pointer select-none' : '',
                                  onClick: header.column.getToggleSortingHandler(),
                                }}
                                justify='space-between'
                                align='center'
                                fontSize={{ sm: "10px", lg: "12px" }}
                                color='gray.400'
                              >
                                {flexRender(header.column.columnDef.header, header.getContext())}
                              </Flex>
                            )}
                          </Th>
                        )
                      })}
                    </Tr>
                  ))}
                </Thead>
                <Tbody>
                  {isLoading
                    ? Array.from({ length: 8 }).map((_, i) => (
                        <Tr key={`skeleton-${i}`}>
                          {columns.map((col, j) => (
                            <Td key={j} borderColor={borderColor} py="14px">
                              <Skeleton height="18px" borderRadius="md" startColor="gray.100" endColor="gray.200" />
                            </Td>
                          ))}
                        </Tr>
                      ))
                    : table.getRowModel().rows.map((row, index) => (
                        <MotionTr
                          px="20px"
                          key={row.id}
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{
                            duration: 0.25,
                            delay: index * 0.035,
                            ease: [0.16, 1, 0.3, 1],
                          }}
                        >
                          {row.getVisibleCells().map(cell => {
                            const isSelectColumn = cell.column.id === 'select';
                            return (
                              <Td
                                key={cell.id}
                                fontSize={{ sm: "14px" }}
                                borderColor={borderColor}
                                transition="all 0.4s cubic-bezier(0.16, 1, 0.3, 1)"
                                w={isSelectColumn ? (multiSelectMode ? "40px" : "0px") : "auto"}
                                minW={isSelectColumn ? "0px" : { sm: "150px", md: "200px", lg: "auto" }}
                                p={isSelectColumn && !multiSelectMode ? "0px" : "12px"}
                              >
                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                              </Td>
                            );
                          })}
                        </MotionTr>
                      ))
                  }
                </Tbody>
              </Table>
            </Box>
            <Flex w="100%" justify="space-between" align="center" px="20px" pt="10px" pb="5px" direction={{ base: "column", md: "row" }} gap={4}>
              {/* Texto informativo de entradas */}
              <Text fontSize='sm' color='gray.500' fontWeight='normal'>
                Mostrando {table.getRowModel().rows.length > 0 ? pageIndex * pageSize + 1 : 0} a{" "}
                {pageIndex * pageSize + table.getRowModel().rows.length} de {table.getFilteredRowModel().rows.length} entradas
              </Text>

              {/* Controles de paginación e inputs */}
              <Flex align="center" gap="10px">
                {/* Selector de tamaño de página (Opcional pero muy útil para UX) */}
                <Select
                  size="sm"
                  value={pageSize}
                  onChange={e => table.setPageSize(Number(e.target.value))}
                  width="110px"
                  borderRadius="md"
                  borderColor={borderColor}
                >
                  {[10, 20, 30, 40, 50].map(size => (
                    <option key={size} value={size}>
                      Ver {size}
                    </option>
                  ))}
                </Select>

                <HStack spacing='4px'>
                  {/* Botón Anterior */}
                  <Button
                    variant='outline'
                    onClick={() => table.previousPage()}
                    isDisabled={!table.getCanPreviousPage()}
                    w='36px'
                    h='36px'
                    borderRadius='50%'
                    borderColor={borderColor}
                    _hover={{ bg: useColorModeValue("gray.100", "whiteAlpha.100") }}
                  >
                    <Icon as={MdChevronLeft} w='16px' h='16px' color={textColor} />
                  </Button>

                  {/* ========================================================= */}
                  {/* NÚMEROS DE PÁGINA DINÁMICOS                               */}
                  {/* ========================================================= */}
                  {Array.from({ length: table.getPageCount() }, (_, index) => {
                    // Lógica para no saturar si hay 50 páginas (Muestra la actual, vecinas y extremos)
                    const totalPages = table.getPageCount();
                    if (
                      index === 0 ||
                      index === totalPages - 1 ||
                      (index >= pageIndex - 1 && index <= pageIndex + 1)
                    ) {
                      return (
                        <Button
                          key={index}
                          onClick={() => table.setPageIndex(index)}
                          variant={pageIndex === index ? "solid" : "outline"}
                          colorScheme={pageIndex === index ? "blue" : "gray"}
                          w='36px'
                          h='36px'
                          borderRadius='50%'
                          fontSize="sm"
                        >
                          {index + 1}
                        </Button>
                      );
                    }

                    // Renderiza el clásico "..." si hay saltos grandes de páginas
                    if (index === 1 || index === totalPages - 2) {
                      return <Text key={index} px={1} color="gray.400">...</Text>;
                    }
                    return null;
                  })}

                  {/* Botón Siguiente */}
                  <Button
                    variant='outline'
                    onClick={() => table.nextPage()}
                    isDisabled={!table.getCanNextPage()}
                    w='36px'
                    h='36px'
                    borderRadius='50%'
                    borderColor={borderColor}
                    _hover={{ bg: useColorModeValue("gray.100", "whiteAlpha.100") }}
                  >
                    <Icon as={MdChevronRight} w='16px' h='16px' color={textColor} />
                  </Button>
                </HStack>

                {/* Input para saltar directo a una página */}
                <HStack spacing={1} pl={2} display={{ base: "none", sm: "flex" }}>
                  <Text fontSize="sm" color="gray.500" whiteSpace="nowrap">Ir a:</Text>
                  <Input
                    size="sm"
                    type="number"
                    defaultValue={pageIndex + 1}
                    onChange={e => {
                      const page = e.target.value ? Number(e.target.value) - 1 : 0;
                      if (page >= 0 && page < table.getPageCount()) {
                        table.setPageIndex(page);
                      }
                    }}
                    width="60px"
                    textAlign="center"
                    borderRadius="md"
                    borderColor={borderColor}
                  />
                </HStack>
              </Flex>
            </Flex>
          </Flex>
        </motion.div>
      </AnimatePresence>

      <AnimatePresence>
        {showBajaForm && (
          <motion.div
            key="form"
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={formVariants}
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              width: '40%', // Mantenemos el ancho original
              height: '100vh', // 100% del viewport height
              backgroundColor: useColorModeValue('white', 'gray.800'),
              boxShadow: '-5px 0 15px rgba(0,0,0,0.1)',
              zIndex: 10,
              overflowY: 'auto', // Scroll si el contenido es muy largo
              padding: '50px'
            }}
          >
            <Button
              onClick={handleCloseBajaFlow}
              position="absolute"
              right="20px"
              top="20px"
              size="sm"
              variant="ghost"
            >
              <Icon as={MdClose} />
            </Button>

            <Box mt="50px">
              <Flex align="center" mb={6}>
                <Box
                  bg="red.100"
                  color="red.500"
                  p={2}
                  borderRadius="full"
                  mr={4}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon as={MdClose} boxSize={6} />
                </Box>
                <Text fontSize="2xl" fontWeight="bold">
                  {currentAsset
                    ? `Dar de baja: ${currentAsset.name}`
                    : `Dar de baja ${selectedAssets.size} activos`}
                </Text>
              </Flex>

              {bajaStep === 1 && (
                <Box>
                  <Text fontSize="lg" fontWeight="semibold" mb={2}>Paso 1: Información básica</Text>
                  <Divider mb={4} />

                  <FormControl mb={4}>
                    <FormLabel>Fecha de baja</FormLabel>
                    <Input
                      type="date"
                      name="fechaBaja"
                      value={bajaData.fechaBaja}
                      onChange={handleBajaInputChange}
                    />
                  </FormControl>
                  {!currentAsset && selectedAssets.size > 0 && (
                    <Box mb={4}>
                      <Text fontWeight="semibold" mb={4}>Activos seleccionados:</Text>
                      <br />
                      <Stack style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                        {Array.from(selectedAssets.entries()).map(([id, { motivo, file }]) => {
                          const asset = data.find(item => item.actions === id);
                          return (
                            <Box
                              key={id}
                              borderWidth="1px"
                              borderRadius="lg"
                              p={6}
                              boxShadow="md"
                              transition="all 0.3s ease"
                              _hover={{
                                transform: "scale(1.01)",
                                boxShadow: "lg",
                              }}
                              bg="white"
                            >
                              <Text fontWeight="bold" fontSize="lg" mb={4} color="gray.700">
                                {asset?.name || `ID: ${id}`}
                              </Text>

                              <FormControl mb={4}>
                                <FormLabel fontSize="sm" color="gray.600">
                                  Motivo específico
                                </FormLabel>
                                <Select
                                  placeholder="Seleccione un motivo"
                                  value={motivo}
                                  onChange={(e) => {
                                    const newMap = new Map(selectedAssets);
                                    newMap.set(id, { ...newMap.get(id)!, motivo: e.target.value });
                                    setSelectedAssets(newMap);
                                  }}
                                >
                                  <option value="obsoleto">Obsoleto</option>
                                  <option value="dañado">Dañado</option>
                                  <option value="perdido">Perdido</option>
                                  <option value="venta">Venta</option>
                                  <option value="otro">Otro</option>
                                </Select>
                              </FormControl>

                              <FormControl>
                                <FormLabel fontSize="sm" color="gray.700" mb={2}>
                                  Subir fotografía
                                </FormLabel>

                                <Box
                                  as="label"
                                  htmlFor={`file-input-${id}`}
                                  border="2px dashed"
                                  borderColor="gray.300"
                                  borderRadius="lg"
                                  p={4}
                                  textAlign="center"
                                  cursor="pointer"
                                  _hover={{
                                    bg: "gray.50",
                                    borderColor: "blue.400",
                                  }}
                                  transition="all 0.2s"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                >
                                  <Text fontSize="sm" color="gray.500">
                                    {file ? `📎 ${file.name}` : "Haz clic para subir una imagen"}
                                  </Text>
                                </Box>

                                <Input
                                  id={`file-input-${id}`}
                                  type="file"
                                  accept="image/*"
                                  display="none"
                                  onChange={(e) => {
                                    const selectedFile = e.target.files?.[0] || null;
                                    const newMap = new Map(selectedAssets);
                                    newMap.set(id, { ...newMap.get(id)!, file: selectedFile });
                                    setSelectedAssets(newMap);
                                  }}
                                />

                                {file && (
                                  <Box mt={4}>
                                    <Text fontSize="sm" mb={2} color="gray.600">
                                      Vista previa:
                                    </Text>
                                    <Image
                                      src={URL.createObjectURL(file)}
                                      alt="Vista previa"
                                      borderRadius="md"
                                      boxSize="120px"
                                      objectFit="cover"
                                      border="1px solid"
                                      borderColor="gray.200"
                                    />
                                    <Text fontSize="xs" mt={2} color="gray.500">
                                      {(file.size / 1024).toFixed(2)} KB
                                    </Text>
                                  </Box>
                                )}
                              </FormControl>

                            </Box>
                          );

                        })}
                      </Stack>
                    </Box>
                  )}

                  <Button
                    leftIcon={<Icon as={MdChevronRight} />}
                    colorScheme="blue"
                    mt="4"
                    onClick={() => setBajaStep(2)}
                    // Condición limpia: si es individual requiere bajaData.motivo, si es múltiple requiere allAssetsHaveMotivo()
                    isDisabled={currentAsset ? !bajaData.motivo : !allAssetsHaveMotivo()}
                  >
                    Siguiente
                  </Button>
                </Box>
              )}

              {bajaStep === 2 && (
                <Box>
                  <Text mb={4}>Paso 2: Detalles adicionales</Text>

                  <FormControl mb={4}>
                    <FormLabel>Responsable</FormLabel>
                    <Input
                      name="responsable"
                      value={bajaData.responsable}
                      onChange={handleBajaInputChange}
                      placeholder="Nombre del responsable"
                    />
                  </FormControl>

                  <FormControl mb={4}>
                    <FormLabel>Comentarios</FormLabel>
                    <Textarea
                      name="comentarios"
                      value={bajaData.comentarios}
                      onChange={handleBajaInputChange}
                      placeholder="Detalles adicionales sobre la baja"
                    />
                  </FormControl>

                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                    <FormControl>
                      <FormLabel>Firmante</FormLabel>
                      <Input
                        name="firmante"
                        value={bajaData.firmante}
                        onChange={handleBajaInputChange}
                        placeholder="Nombre del firmante"
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel>Correo del firmante</FormLabel>
                      <Input
                        type="email"
                        name="correoFirmante"
                        value={bajaData.correoFirmante}
                        onChange={handleBajaInputChange}
                        placeholder="firmante@empresa.com"
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel>Jefe de área</FormLabel>
                      <Input
                        name="jefe"
                        value={bajaData.jefe}
                        onChange={handleBajaInputChange}
                        placeholder="Nombre del jefe de área"
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel>Correo del jefe de área</FormLabel>
                      <Input
                        type="email"
                        name="correoJefe"
                        value={bajaData.correoJefe}
                        onChange={handleBajaInputChange}
                        placeholder="jefe@empresa.com"
                      />
                    </FormControl>
                  </SimpleGrid>

                  <Flex justify="space-between" mt={6}>
                    <Button
                      leftIcon={<Icon as={MdChevronLeft} />}
                      variant="outline"
                      onClick={() => setBajaStep(1)}
                    >
                      Atrás
                    </Button>
                    <Button
                      colorScheme="blue"
                      onClick={() => setBajaStep(3)}
                    >
                      Siguiente
                    </Button>
                  </Flex>
                </Box>
              )}


              {bajaStep === 3 && (
                <Box>
                  <Text mb={4}>Paso 3: Confirmación</Text>
                  <Text>
                    {currentAsset
                      ? '¿Está seguro que desea dar de baja este activo?'
                      : `¿Está seguro que desea dar de baja los ${selectedAssets.size} activos seleccionados?`}
                  </Text>
                  <Box mt={4} p={4} bg="gray.50" borderRadius="lg" border="1px solid" borderColor="gray.200">
                    <Stack spacing={2}>
                      <Text><strong>📝 Motivo:</strong> {bajaData.motivo || 'No especificado'}</Text>
                      <Text><strong>📅 Fecha:</strong> {bajaData.fechaBaja}</Text>
                      <Text><strong>👤 Responsable:</strong> {bajaData.responsable || 'No especificado'}</Text>
                      <Text><strong>💬 Comentarios:</strong> {bajaData.comentarios || 'Ninguno'}</Text>
                    </Stack>
                  </Box>

                  <Flex justify="space-between" mt="6">
                    <Button
                      variant="outline"
                      onClick={() => setBajaStep(2)}
                    >
                      Atrás
                    </Button>
                    <Button
                      leftIcon={<Icon as={MdClose} />}
                      colorScheme="red"
                      onClick={handleCompleteBaja}
                    >
                      {currentAsset ? 'Confirmar baja' : `Dar de baja (${selectedAssets.size})`}
                    </Button>
                  </Flex>
                </Box>
              )}
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
}
